import Box, { type BoxProps } from '@liquidweb-dev/undercurrent/Box';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

interface CancellationAlertProps extends BoxProps {
	cancellationDate: string;
	/**
	 * Whether the asset can have its termination scheduled. An asset that
	 * cannot is destroyed as soon as the customer confirms, so the dialog says
	 * nothing about the billing cycle or refunds.
	 */
	canScheduleTerminate: boolean;
}

const CancellationAlert = ({
	sx,
	cancellationDate,
	canScheduleTerminate,
	...boxProps
}: CancellationAlertProps) => {
	return (
		<Box
			sx={combineSx(
				({ vars, borderRadius }) => ({
					border: '1px solid',
					borderColor: vars.palette.uc.highlight.border.medium,
					borderRadius: borderRadius.rounded,
					padding: 200,
				}),
				sx,
			)}
			{...boxProps}
		>
			<Stack spacing={50}>
				<Typography variant="body-md" sx={{ fontWeight: 500 }}>
					Cancellation date:{' '}
					<Typography variant="body-md" sx={{ fontWeight: 700 }}>
						{cancellationDate}
					</Typography>
				</Typography>
				{canScheduleTerminate && (
					<Typography variant="body-sm">
						Service stays active until your billing cycle ends.
						<br />
						No refund will be issued.
					</Typography>
				)}
			</Stack>
		</Box>
	);
};

export default CancellationAlert;
